import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "./assets/images/logo.svg";

const CONTACT_URL = "https://www.c-metric.com/contact/";

function Nav({ setToken }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isLoggedIn = sessionStorage.getItem("token") === "loggedIn";

  useEffect(() => setMenuOpen(false), [location.pathname, location.hash]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setToken(null);
    navigate("/login");
  };

  const navClass = ({ isActive }) => `nav-link${isActive ? " is-active" : ""}`;

  return (
    <nav className={`navbar navbar-expand-lg aivio-navbar${scrolled ? " is-scrolled" : ""}`}>
      <div className="container">
        <Link className="navbar-brand" to="/" aria-label="Aivio home"><img src={logo} alt="Aivio" className="logo" /></Link>
        <button className="navbar-toggler" type="button" onClick={() => setMenuOpen((open) => !open)} aria-controls="navbarNav" aria-expanded={menuOpen} aria-label="Toggle navigation"><span className="navbar-toggler-icon" /></button>
        <div className={`collapse navbar-collapse${menuOpen ? " show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item"><Link className="nav-link" to="/#agents">Product</Link></li>
            <li className="nav-item"><NavLink className={navClass} to="/use-cases">Use cases</NavLink></li>
            <li className="nav-item"><NavLink className={navClass} to="/know-your-cost">Estimate your cost</NavLink></li>
            <li className="nav-item"><a className="nav-link" href={CONTACT_URL} target="_blank" rel="noreferrer">Book a demo</a></li>
            {!isLoggedIn ? <><li className="nav-item nav-account"><NavLink className={navClass} to="/login">Log in</NavLink></li><li className="nav-item"><Link className="nav-link nav-cta" to="/register">Get started <span>→</span></Link></li></> : <li className="nav-item nav-account"><button type="button" className="nav-link" onClick={handleLogout}>Log out</button></li>}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
